const TEXT = "think deeper · see bigger · stay curious · question kindly · for the love of philosophy · ";

export const OrbitText = () => (
  <svg viewBox="0 0 400 400" aria-hidden="true" className="ph-orbit absolute inset-0 w-full h-full">
    <defs>
      <path id="orbitPath" d="M200,200 m-170,0 a170,170 0 1,1 340,0 a170,170 0 1,1 -340,0" />
    </defs>
    <circle cx="200" cy="200" r="150" fill="none" stroke="currentColor" strokeOpacity="0.28" strokeWidth="1" />
    <circle cx="200" cy="200" r="192" fill="none" stroke="currentColor" strokeOpacity="0.16" strokeWidth="1" strokeDasharray="2 6" />
    <g className="ph-orbit-spin">
      <text fill="currentColor" fontSize="15" letterSpacing="4" className="font-body uppercase" fillOpacity="0.85">
        <textPath href="#orbitPath" textLength="1060" lengthAdjust="spacing">{TEXT}</textPath>
      </text>
    </g>
  </svg>
);
